module.exports = __webpack_public_path__ + "static/media/flag2.a8e6c2d7.svg";